import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import IImportation, { IImportationInput } from "@/interfaces/importation.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ImportationService {
  private baseUrl = "api/v1/importprocess";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IImportation>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const importations = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return importations;
  }

  async filter(
    filter: IFilter<IImportation>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IImportation>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });
    return response;
  }

  async create(formData: IImportationInput): Promise<IImportation> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async getById(importationId: number): Promise<IImportation> {
    return await httpRequest.get(`${this.baseUrl}/${importationId}`);
  }

  async update(formData: IImportationInput, importationId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${importationId}`, formData);
  }

  async delete(importationId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${importationId}`);
  }
}

const importationService = new ImportationService();
export default importationService;
